import React, { useEffect, useState, useRef } from "react";
import './Libroblanco2026.css';
import { useTranslation } from 'react-i18next';
import YoutubeLite from "../../components/YoutubeLite/YoutubeLite";


const Libroblanco2026 = () => {
    const [t, i18n] = useTranslation("global");
    const [t2] = useTranslation("home");
    const [t3] = useTranslation("detail_blog");
    const [t4] = useTranslation("biblioteca");
    const [t5] = useTranslation("libroAzul");
    const [t6] = useTranslation("librBlanc");

    return (
        <>
            <div class="_nghost-ng-c4013722087">
                <article aria-labelledby="book-detail-title" class="book-detail-page">
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c4098101840"><a
                        class="book-detail-page__back-link"
                        href={"/" + i18n.language + "/biblioteca"}>{t("general.back-library")}</a>
                        <div class="book-detail-page__cover"><img
                            src="/assets/img2026/book_details_blanco.png"
                            alt="Portada del libro Ideas que transforman negocios para cambiar al mundo" loading="eager"
                            fetchpriority="high" /></div>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c3469483597">
                        <section class="book-detail-page__intro">
                            <h1 id="book-detail-title">{t2("2026.libro4")}</h1>
                        </section>
                    </div>
                    
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c3568423662">
                        <section class="book-detail-page__content book-detail-page__content-noborder">
                            <blockquote class="book-detail-page__content-quote">
                                <p class="book-detail-page__content-quote-text">{t6("2026.frase")}</p><cite
                                    class="book-detail-page__content-quote-author">– Ricardo Salinas</cite>
                            </blockquote>
                        </section>
                    </div>

                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c2131526924">
                        <section class="book-detail-page__content book-detail-page__content-noborder">
                            <p class="book-detail-page__lead">{t6("2026.texto1")}</p>
                            <p class="book-detail-page__content-body">{t6("2026.texto2")}</p>
                        </section>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c411527492">
                        <section aria-labelledby="book-detail-feature-title"
                            class="book-detail-feature">
                            <article class="book-detail-feature__media">
                                <YoutubeLite videoId="jlS9EmHZKLM" />
                            </article>
                            <div class="book-detail-feature__copy">
                                <h2 id="book-detail-feature-title" class="book-detail-feature__title">{t6("2026.subtitulo1")}</h2>
                                <p>{t6("2026.desc")}</p>
                                <a target="_blank" class="book-detail-feature__cta boton-compra-only-desk"
                                    href="https://www.amazon.com.mx/Ideas-sobre-libertad-cambian-mundo-ebook/dp/B09HX3BG8T/ref=tmm_kin_swatch_0?_encoding=UTF8&qid=1703270322&sr=8-2">{t5("header.buy")}</a>
                            </div>
                        </section>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c2882487804">
                        <section aria-label="Videos del libro" class="book-detail-video-gallery">
                            <article class="book-detail-video-gallery__card">
                                {/*<img src="/assets/img2026/book_detail_video_0.png"
                                    alt="Entrevista sobre el libro" loading="lazy" class="book-detail-video-gallery__image" />*/}
                                <YoutubeLite videoId="2hQyaequlR8" />
                            </article>
                            <article class="book-detail-video-gallery__card">
                                {/* <img src="/assets/img2026/book_detail_video_1.png"
                                alt="Libro abierto con fondo azul" loading="lazy" class="book-detail-video-gallery__image" />*/}
                                <YoutubeLite videoId="mJNMPKlztYY" />
                            </article>
                        </section>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c3568423662">
                        <section class="book-detail-page__content">
                            <blockquote class="book-detail-page__content-quote">
                                <p class="book-detail-page__content-quote-text">{t5("reason.quote-reason-b")}</p><cite
                                    class="book-detail-page__content-quote-author">– Ricardo Salinas</cite>
                            </blockquote>
                        </section>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c3500518879">
                        <section id="buy-section" aria-labelledby="book-stores-title"
                            class="book-detail-page__stores">
                            <h2 id="book-stores-title">{t5("libraries.donde")}</h2>
                            <div class="store-row">
                                <h3>{t5("libraries.available-inprestigious")}</h3>
                                <div class="store-row__logos">
                                    <a target="_blank" rel="noreferrer" href="https://www.gandhi.com.mx/ideas-que-transforman-negocios-para-cambiar-el-mundo/p" aria-label="Ir a Gandhi">
                                        <img
                                            loading="lazy" src="/assets/img2026/logo_gandhi.png"
                                            alt="Gandhi" />
                                    </a>

                                    <img loading="lazy"
                                        src="/assets/img2026/El_Sotano_Logo.png" alt="el sotano" />


                                    <img
                                        loading="lazy" src="/assets/img2026/logo_porrua.png" alt="Porrúa" />

                                    <img loading="lazy"
                                        src="/assets/img2026/gonvil.png" alt="gonvil" />

                                    <img loading="lazy"
                                        src="/assets/img2026/fondo-cultura.png" alt="fondo" />

                                    <img loading="lazy"
                                        src="/assets/img2026/pendulo.png" alt="pendulo" />


                                </div>
                            </div>
                            {/* 
                            <div class="store-row">
                                <h3>{t5("libraries.available-as-audio")}</h3>
                                <div class="store-row__logos">
                                    <a
                                        target="_blank" rel="noreferrer" href="https://www.audible.com/es_US/pd/Ideas-que-transforman-negocios-para-cambiar-al-mundo-Audiolibro/B0D9NQK7CZ?eac_link=PPRiX7CXUFl7&ref=web_search_eac_asin_1&eac_selected_type=asin&eac_selected=B0D9NQK7CZ&qid=s182U1YXeU&eac_id=141-4088558-2166039_s182U1YXeU&sr=1-1"
                                        aria-label="Ir a Audible">
                                        <img loading="lazy"
                                            src="/assets/img2026/logo_audible.png" alt="Audible" />
                                    </a>
                                </div>
                            </div>*/}
                            <div class="store-row">
                                <h3>{t5("libraries.available-as-eBook")}</h3>
                                <div class="store-row__logos">
                                    <a
                                        target="_blank" rel="noreferrer" href="https://www.amazon.com.mx/Ideas-sobre-libertad-cambian-mundo-ebook/dp/B09HX3BG8T/ref=tmm_kin_swatch_0?_encoding=UTF8&qid=1703270322&sr=8-2" aria-label="Ir a Kindle">
                                        <img
                                            loading="lazy" src="/assets/img2026/logo_amazon.png"
                                            alt="Kindle" />
                                    </a>

                                </div>
                            </div>
                        </section>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c411527492">
                        <section aria-labelledby="book-detail-feature-title"
                            class="book-detail-feature">
                            <article class="book-detail-feature__media">
                                <YoutubeLite videoId="Y4H5Sn5lfJI" />
                            </article>
                            <div class="book-detail-feature__copy">
                                <h2 id="book-detail-feature-title" class="book-detail-feature__title">{t6("2026.subtitulo2")}</h2>
                                <p>{t6("2026.ideas1")}</p>
                                <p>{t6("2026.ideas2")}</p>
                            </div>

                        </section>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c2882487804">
                        <section aria-label="Videos del libro" class="book-detail-video-gallery">
                            <article class="book-detail-video-gallery__card">
                                <YoutubeLite videoId="8D50sP-CHw8" />
                            </article>
                            <article class="book-detail-video-gallery__card">
                                <YoutubeLite videoId="oa2DF2y0OVU" />
                            </article>
                        </section>
                    </div>
                    <div class="_nghost-ng-c3151073329 fragmento-lib">
                        <section aria-label="Suscripción al boletín" class="blog-newsletter-cta">
                            <div class="blog-newsletter-cta__container">
                                <p class="blog-newsletter-cta__message"><span
                                    class="blog-newsletter-cta__message-desktop">{t("general.lib3")}</span><span
                                        class="blog-newsletter-cta__message-mobile">{t("general.lib3")}</span></p>
                                <a href="https://www.ricardosalinas.com/Content/assets/documents/ideas-BLANCO-PROLOGOS.pdf" target="_blank" download="fragmento-libro-sociedades.pdf" rel="noreferrer">
                                    <button
                                        type="button" class="blog-newsletter-cta__button"><span
                                            class="blog-newsletter-cta__button-desktop">{t("general.libbtn")}</span><span
                                                class="blog-newsletter-cta__button-mobile">{t("general.libbtn2")}</span></button></a>
                            </div>
                        </section>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c3138913358">
                        <section aria-labelledby="book-collection-title"
                            class="book-detail-page__collection">
                            <h2 id="book-collection-title" class="book-detail-page__collection-title">
                                {t5("aslo.aslo")}</h2>
                            <div class="book-collection-list">

                                <article class="book-collection-card"><img
                                    loading="lazy" class="book-collection-card__image" src="/assets/img2026/book_cover_1.png"
                                    alt="Portada del libro Ideas sobre la libertad para cambiar al mundo" />
                                    <div class="book-collection-card__copy">
                                        <p class="book-collection-card__author">Ricardo Salinas</p>
                                        <h3 class="book-collection-card__title">{t2("2026.libro2")}</h3>
                                        <p class="book-collection-card__summary">{t4("2026.desc2")}
                                        </p><a class="book-collection-card__link"
                                            href={"/" + i18n.language + "/LibroNegocios"}>{t2("2026.bookmore")}</a>
                                    </div>
                                </article>
                                <article class="book-collection-card"><img
                                    loading="lazy" class="book-collection-card__image" src="/assets/img2026/book_cover_2.png"
                                    alt="Portada del libro Ideas que transforman sociedades para cambiar al mundo" />
                                    <div class="book-collection-card__copy">
                                        <p class="book-collection-card__author">Ricardo Salinas</p>
                                        <h3 class="book-collection-card__title">{t2("2026.libro3")}</h3>
                                        <p class="book-collection-card__summary">{t4("2026.desc3")}
                                        </p><a class="book-collection-card__link"
                                            href={"/" + i18n.language + "/LibroSociedades"}>{t2("2026.bookmore")}</a>
                                    </div>
                                </article>
                            </div>
                        </section>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c411527492 flotante-comprar">

                        <a target="_blank" class="book-detail-feature__cta"
                            href="https://www.amazon.com.mx/Ideas-sobre-libertad-cambian-mundo-ebook/dp/B09HX3BG8T/ref=tmm_kin_swatch_0?_encoding=UTF8&qid=1703270322&sr=8-2">{t5("header.buy2")}</a>

                    </div>
                </article>
            </div>
        </>
    );
};
export default Libroblanco2026;